export const BlobContainerConsts = {
  GameType: "game-type",
  Banks: "banks",
  UserDocuments: "user-documents",
  BankAttachment: "bank-attachment",
  DepositBonus: "deposit-bonus-document",
  DepositPaymentMethod: "deposit-payment-method",
  WithdrawType: "withdraw-type",
  WithdrawFee: "withdraw-fee",
  GameCategory: "game-category",
  GameBanner: "GameBanner",
  GameSupplier: "game-supplier",
  MasterAffiliateTags: "social-media-links",
  UserAvatar: "user-avatar"
};